import React, { useState, useEffect, useContext } from 'react'
import { Col, Alert, Container, Button, Form } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { AuthContext } from './AuthContext'

import Logo from '../image/logo.png'
import Footer from './Footer'
import axios from 'axios'
import Cookies from 'js-cookie'

// 第三方登入
import { FacebookLoginButton } from 'react-social-login-buttons'
import { GoogleLoginButton } from 'react-social-login-buttons'
import { LoginSocialFacebook } from 'reactjs-social-login'
import { LoginSocialGoogle } from 'reactjs-social-login'
import { useNavigate } from 'react-router-dom'

// import jwt_decode from 'jwt-decode'

const Login = () => {
  const { setCurrentUser, BaseUrl, setIsLoading, sendDiscordNotification } =
    useContext(AuthContext)
  const [errShow, setErrShow] = useState({ show: false, msg: '' })
  const [account, setAccount] = useState('')
  const [password, setPassword] = useState('')

  const [googleUser, setGoogleUser] = useState(null)
  const [fbUser, setFbUser] = useState(null)
  // 30 分鐘過期
  const cookieOptions = { expires: 1 / 48, secure: true }
  const login = 'member/v1/Login'
  const loginWithExternalAccount = 'member/v1/LoginWithExternalAccount'
  const navigate = useNavigate()

  useEffect(() => {
    setIsLoading(false)
  }, [])

  // 拿到五個之後存cookie
  const handleSubmit = (e) => {
    setIsLoading(true)
    e.preventDefault()
    // const sanitizedValue = value.replace(/[^a-zA-Z0-9]/g, '')
    axios
      .post(
        BaseUrl + login,
        {
          id: account,
          pass: password,
        },
        {
          headers: {
            'Content-Type': 'text/plain; charset=UTF-8',
            Accept: '*/*',
          },
        }
      )
      .then((res) => {
        if (res.data.tk) {
          setIsLoading(false)
          navigate('/')
          // console.log('currerent login', res.data)
          const { inc_id, tk, kol_id, kol_name, lv, inc_name, inc_icon } =
            res.data
          const userData = { ...res.data, isLocked: false }
          if (!Cookies.get('tk')) {
            Cookies.set('tk', JSON.stringify(userData), cookieOptions)
          }
          setCurrentUser({
            inc_id: inc_id,
            tk: tk,
            kol_id: kol_id,
            kol_name: kol_name,
            lv: lv,
            inc_name: inc_name,
            inc_icon: inc_icon,
            // TODO:
            isLocked: false,
          })
        } else if (res.data.code === '1002' || res.data.code === '0004') {
          setIsLoading(false)
          // 找不到資源
          setErrShow({ show: true, msg: '帳號或密碼錯誤' })
          sendDiscordNotification(`登入錯誤: ${res.data.msg}`)
          console.log('res', res)
        } else {
          // 其他
          setIsLoading(false)
          setErrShow({ show: true, msg: '帳號或密碼錯誤' })
        }
      })
      .catch((e) => {
        setIsLoading(false)
        setErrShow({ show: true, msg: '伺服器忙碌中，請稍後再試' })
        sendDiscordNotification(`伺服器掛了: ${e}`)

        console.log(e)
      })
  }

  useEffect(() => {
    if (fbUser) {
      setIsLoading(true)

      axios
        .post(
          BaseUrl + loginWithExternalAccount,
          {
            source: 'fb',
            bind_id: fbUser.userID,
            bind_token: fbUser.accessToken,
          },
          {
            headers: {
              'Content-Type': 'text/plain; charset=UTF-8',
              Accept: '*/*',
            },
          }
        )
        .then((res) => {
          console.log('FB', res)

          if (res.data.tk) {
            navigate('/')

            const { inc_id, tk, kol_id, kol_name, lv, inc_name, inc_icon } =
              res.data
            const userData = {
              ...res.data,
              isLocked: true,
              displayName: fbUser.name,
            }

            if (!Cookies.get('tk')) {
              Cookies.set('tk', JSON.stringify(userData), cookieOptions)
            }
            setCurrentUser({
              inc_id: inc_id,
              tk: tk,
              kol_id: kol_id,
              kol_name: kol_name,
              lv: lv,
              inc_name: inc_name,
              inc_icon: inc_icon,
              isLocked: true,
              displayName: fbUser.name,
            })
          } else {
            // 找不到資源

            setErrShow({ show: true, msg: '請重新登入' })
            sendDiscordNotification(
              `第三方登入錯誤/找不到資源: ${res.data.msg}`
            )
          }
        })
        .catch((e) => {
          setErrShow({ show: true, msg: '伺服器忙碌中，請稍後再試' })
          sendDiscordNotification(`第三方登入錯誤/伺服器掛了: ${e}`)
          console.log(e)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [fbUser])

  useEffect(() => {
    if (googleUser) {
      setIsLoading(true)
      axios
        .post(
          BaseUrl + loginWithExternalAccount,
          {
            source: 'yt',
            bind_id: googleUser.sub,
            bind_token: googleUser.access_token,
          },
          {
            headers: {
              'Content-Type': 'text/plain; charset=UTF-8',
              Accept: '*/*',
            },
          }
        )
        .then((res) => {
          navigate('/')

          console.log('Google', res)
          if (res.data.tk) {
            const { inc_id, tk, kol_id, kol_name, lv, inc_name, inc_icon } =
              res.data
            const userData = {
              ...res.data,
              isLocked: true,
              displayName: googleUser.name,
            }

            if (!Cookies.get('tk')) {
              Cookies.set('tk', JSON.stringify(userData), cookieOptions)
            }
            setCurrentUser({
              inc_id: inc_id,
              tk: tk,
              kol_id: kol_id,
              kol_name: kol_name,
              lv: lv,
              inc_name: inc_name,
              inc_icon: inc_icon,
              isLocked: true,
              displayName: googleUser.name,
            })
          } else {
            // 找不到資源
            setErrShow({ show: true, msg: '請重新登入' })
            sendDiscordNotification(
              `第三方登入錯誤/找不到資源: ${res.data.msg}`
            )
          }
        })
        .catch((e) => {
          setErrShow({ show: true, msg: '伺服器忙碌中，請稍後再試' })
          sendDiscordNotification(`第三方登入錯誤/伺服器掛了: ${e}`)
          console.log(e)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [googleUser])

  const fbId = process.env.REACT_APP_FB_ID
  const googleId = process.env.REACT_APP_GOOGLE_ID

  return (
    <div className="bg-warning">
      <Helmet>
        <title>登入 | KOLSTAR</title>
      </Helmet>
      <Container className="login d-flex flex-column justify-content-center align-items-center position-relative">
        <div className="imgwrap_logo">
          <img className="w-100" src={Logo} alt="logo" />
        </div>
        <div className="loginBtnGroup mt-4 ">
          <LoginSocialFacebook
            // isOnlyGetToken
            appId={fbId || ''}
            onResolve={({ data }) => {
              setFbUser(data)
              console.log('fbuser data', data)
            }}
            onReject={(error) => {
              setErrShow({ show: true, msg: '請重新登入' })
              console.log(error)
            }}
          >
            <FacebookLoginButton />
          </LoginSocialFacebook>
          <LoginSocialGoogle
            // isOnlyGetToken
            client_id={googleId || ''}
            onResolve={({ data }) => {
              setGoogleUser(data)
              console.log('googleuser data', data)
            }}
            onReject={(error) => {
              setErrShow({ show: true, msg: '請重新登入' })
              console.log(error)
            }}
          >
            <GoogleLoginButton />
          </LoginSocialGoogle>
        </div>
        <h4 className="fw-bold my-3 opacity-50">or</h4>
        <Col xs={10} sm={8} md={6} lg={4} className="mb-5">
          <div className="loginCard d-flex flex-column justify-content-center align-items-center border border-light rounded rounded-3 bg-light bg-opacity-25 mb-5">
            <h3 className="fw-bold my-3 text-dark">Login</h3>
            <Col xs={10}>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="ControlInput1">
                  <Form.Control
                    type="text"
                    placeholder="Username"
                    value={account}
                    onChange={(e) =>
                      // 移除特殊字符
                      setAccount(e.target.value.replace(/[^a-zA-Z0-9]/g, ''))
                    }
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="ControlInput2">
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) =>
                      setPassword(e.target.value.replace(/[^a-zA-Z0-9]/g, ''))
                    }
                  />
                </Form.Group>

                {errShow.show && (
                  <Alert
                    variant="danger"
                    onClose={() => setErrShow({ show: false, msg: '' })}
                    dismissible
                  >
                    <i className="fa-solid fa-triangle-exclamation"></i>{' '}
                    {errShow.msg}
                  </Alert>
                )}

                <Button type="submit" className="w-100 mt-3 mb-3">
                  Login
                </Button>
              </Form>
            </Col>
          </div>
        </Col>
        <div className="loginFooter mb-md-3">
          <Footer />
        </div>
      </Container>
    </div>
  )
}

export default Login
